const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'general.attachments/SET_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    default:
      return state;
  }
}
